// src/pages/TermsOfServicePage.js - 이용약관 페이지

import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../context/AppContext';
import './TermsOfServicePage.scss';

const TermsOfServicePage = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAppContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    const targetPath = isLoggedIn ? '/' : '/login';
    navigate(targetPath, { replace: true });
    window.scrollTo(0, 0);
  };

  return (
    <div className="terms-page">
      {/* Header */}
      <header className="terms-header">
        <div className="container">
          <div className="terms-header-content">
            <button 
              className="terms-back-button"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <div className="logo">
              <Link to="/">
                <h1>ReOpsAI</h1>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="terms-content-section">
        <div className="container">
          <div className="terms-wrapper">
            <h1 className="terms-title">ReOpsAI 이용약관</h1>
            <p className="terms-updated-date">수정일자: 2026년 7월 29일 | 시행일자: 2025년 11월 17일</p>
            
            <div className="terms-body">
              <section className="terms-section">
                <h2>제1조 (목적)</h2>
                <p>
                  본 이용약관(이하 "본 약관"이라고 합니다)은 주식회사 피엑스디(이하 "회사"라고 합니다)가 운영하는 
                  ReOpsAI(<a href="http://www.reopsai.com">www.reopsai.com</a>, 이하 "리옵스에이아이"라 합니다)에서 제공하는 
                  인터넷 관련 서비스(이하 "서비스"라고 합니다)를 이용자가 이용함에 있어 회사와 이용자의 기본적인 권리, 
                  의무, 책임사항 등 이용자와 회사 사이 중요 사항을 규정함을 목적으로 합니다.
                </p>
              </section>

              <section className="terms-section">
                <h2>제2조 (정의)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> "회사"란 리옵스에이아이를 통해 서비스를 제공하는 주식회사 피엑스디를 의미합니다.</p>
                  <p><strong>2.</strong> "리옵스에이아이"란 회사가 이용자에게 제공하는 서비스 명칭임과 동시에 회사가 서비스를 제공하기 위하여 
                  컴퓨터 등 정보통신설비를 이용하여 서비스를 제공하고 거래할 수 있도록 설정한 가상의 영업장 또는 서비스 공간을 의미하며, 
                  아울러 서비스를 제공하는 주체를 지칭하는 용도로도 사용될 수 있습니다.</p>
                  <p><strong>3.</strong> "이용자"란 리옵스에이아이에 접속하여 본 약관에 따라 리옵스에이아이가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</p>
                  <p><strong>4.</strong> "회원"이란 본 약관에 따라 리옵스에이아이에 회원등록을 한 자로서, 계속적으로 리옵스에이아이가 제공하는 서비스를 이용하는 자를 말합니다.</p>
                  <p><strong>5.</strong> "비회원"이라 함은 회원에 가입하지 않고 리옵스에이아이가 제공하는 서비스를 이용하는 자를 말합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제3조 (약관 등의 명시와 설명 및 개정)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 본 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전자우편주소, 사업자등록번호, 
                  통신판매업 신고번호, 개인정보관리책임자 등을 연결화면을 통하여 게시합니다.</p>
                  <p><strong>2.</strong> 회사는 회원가입 시 이용자에게 회원가입 행위가 본 약관에 동의하는 행위임을 알리고 본 약관의 내용을 
                  연결화면을 통하여 볼 수 있도록 합니다.</p>
                  <p><strong>3.</strong> 회사는 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</p>
                  <p><strong>4.</strong> 회사가 본 약관을 개정할 경우에는 개정사유를 명시하여 현행약관, 개정약관을 모두 볼 수 있도록 하여 
                  서비스의 게시판에 개정 약관 적용 7일 이전부터 적용일자 전일까지 공지하며 회원 각 개인의 이메일로 개정 약관 적용 7일 이전에 
                  개정 내용을 발송합니다.</p>
                  <p><strong>5.</strong> 회사가 본 약관을 개정할 경우에는 제4항에 의한 방법으로 회원들에게 개정 사항을 알리며 개정 약관 적용 7일 이전부터 
                  적용일자 전일까지 이의 의사를 회사측에 표명하지 않으면 개정 약관에 동의하는 것으로 간주합니다.</p>
                  <p><strong>6.</strong> 본 약관에서 정하지 아니한 사항과 본 약관의 해석에 관하여는 관계법령 또는 상관례에 따릅니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제4조 (서비스의 제공 및 변경)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 다음과 같은 업무를 수행합니다.</p>
                  <div className="terms-list-item">
                    <p>가. 서비스에 대한 정보 제공 및 서비스 제공에 대한 계약의 체결</p>
                    <p>나. 체결된 서비스 제공 계약에 따라 서비스 제공</p>
                    <p>다. 기타 회사가 정하는 업무</p>
                  </div>
                  <p><strong>2.</strong> 회사는 서비스의 품질 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 서비스의 내용을 변경할 수 있습니다.</p>
                  <p><strong>3.</strong> 회사가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 기술적 사양의 변경 등의 사유로 변경할 경우에는 
                  그 사유를 이용자에게 통지 가능한 전자우편 주소로 즉시 통지합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제5조 (서비스의 이용과 중단)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 리옵스에이아이가 서비스 제공에 활용하는 외부 LLM 서비스 등 외부 제휴업체의 사유로 정상적인 서비스 제공이 어려운 경우를 
                  포함하여 관계 법령의 변경, 천재지변, 디도스(DDOS) 공격, IDC 장애, 기간통신사업자의 회선 장애 또는 이에 준하는 불가항력으로 인하여 
                  서비스의 제공이 일시적으로 중단될 수 있고, 이 경우 회사는 서비스 제공에 대한 책임이 면책됩니다.</p>
                  <p><strong>2.</strong> 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>
                  <p><strong>3.</strong> 제2항의 사유로 사전 고지 없이 유료 서비스의 제공이 일시적으로 중단되거나 장애가 발생하는 경우 회사는 이에 대한 보상으로 
                  유료 서비스를 이용하는 회원에 한하여 서비스 중단 또는 장애가 발생한 시간당 일수(1일 24시간 기준)의 3배수 기간동안 서비스 이용기간을 추가로 제공합니다.</p>
                  
                  <div className="terms-highlight">
                    <strong>보상 기준 예시:</strong>
                    <ul>
                      <li>7월 10일 오전 10시 ~ 오후 10시 총 12시간 동안 장애 → 장애시간 12시간(1일 이내) → 총 3일 연장</li>
                      <li>7월 10일 오후 10시 ~ 7월 11일 오후 1시 총 15시간 동안 장애 → 장애시간 15시간(1일 이내) → 총 3일 연장</li>
                      <li>7월 10일 오전 10시 ~ 7월 11일 오후 1시 총 27시간 동안 장애 → 장애시간 27시간(2일 이내) → 총 6일 연장</li>
                    </ul>
                  </div>

                  <p><strong>4.</strong> 단, 유료 서비스의 중단 또는 장애를 1일전 사전 고지하거나 회사에게 고의 또는 중과실이 없는 경우, 제1항의 경우에는 그러하지 아니합니다.</p>
                  <p><strong>5.</strong> 사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 더 이상 서비스를 제공할 수 없게 되는 경우 리옵스에이아이는 
                  제8조에 정한 방법으로 이용자에게 통지하고 통지를 통해 회사에서 제시한 조건에 따라 이용자에게 보상합니다.</p>
                  <p><strong>6.</strong> 회사는 리옵스에이아이를 이용한 서비스에 대한 결과 값의 정확성, 적법성, 무결성 등을 보장하지 않습니다. 회사는 이용자가 서비스를 이용하여 
                  기대하는 수익을 얻지 못한 것에 대하여 책임을 지지 않으며, 서비스를 통하여 얻은 결과물로 인한 손해에 관하여 책임을 지지 않습니다.</p>
                  <p><strong>7.</strong> 리옵스에이아이는 서비스 제공에 외부 LLM 서비스 등 외부 제휴업체 서비스를 활용하고 있으며, 서비스 이용 그 자체 또는 서비스 결과 값의 이용과 
                  관련하여 발생하는 모든 문제에 대한 책임은 서비스를 이용하는 이용자에게 있으며, 회사는 이에 대하여 일체의 책임을 지지 아니합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제6조 (회원가입)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입하는 것으로 본 약관에 동의한다는 의사표시를 대체하여 회원가입을 신청합니다.</p>
                  <p><strong>2.</strong> 회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.</p>
                  <div className="terms-list-item">
                    <p>가. 가입신청자가 본 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우</p>
                    <p>나. 등록 내용에 허위, 기재누락, 오기가 있는 경우</p>
                    <p>다. 기타 회원으로 등록하는 것이 서비스의 기술상 현저히 지장이 있다고 판단되는 경우</p>
                  </div>
                  <p><strong>3.</strong> 회원가입의 시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.</p>
                  <p><strong>4.</strong> 회원은 회원가입 시 등록한 사항에 변경이 있는 경우, 상당한 기간 이내에 회사에 대하여 회원정보 수정 등의 방법으로 그 변경사항을 알려야 합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제7조 (회원 탈퇴 및 자격 상실 등)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회원이 언제든 탈퇴할 수 있도록 서비스내 탈퇴 기능을 제공합니다.</p>
                  <p><strong>2.</strong> 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 또는 정지시킬 수 있습니다.</p>
                  <div className="terms-list-item">
                    <p>가. 가입 신청 시에 허위 내용을 등록한 경우</p>
                    <p>나. 서비스의 대금, 기타 서비스 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우</p>
                    <p>다. 다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</p>
                    <p>라. 서비스를 이용하여 법령 또는 본 약관이 금지하거나 본 약관에 위반되거나 공서양속에 반하는 행위를 하는 경우</p>
                    <p>마. 가입 후 리옵스에이아이 생성 기록이 없으며, 최근 1년간 접속한 기록이 없고, 가입 시 입력한 이메일 주소를 인증 받지 않은 경우</p>
                  </div>
                  <p><strong>3.</strong> 회사가 회원 자격을 제한 또는 정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 
                  회사는 회원자격을 상실시킬 수 있습니다.</p>
                  <p><strong>4.</strong> 회사가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 
                  최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제8조 (회원에 대한 통지)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사가 회원에 대한 통지를 하는 경우, 회원이 리옵스에이아이 가입 시 제공한 전자우편 주소로 할 수 있습니다.</p>
                  <p><strong>2.</strong> 회사는 불특정 다수의 회원에 대한 통지의 경우 1주일간 서비스의 공지사항에 게시 함으로서 개별 통지에 갈음할 수 있습니다. 
                  다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별 통지를 합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제9조 (서비스 제공신청 및 개인정보 제공 동의 등)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 이용자는 리옵스에이아이에서 다음 또는 이와 유사한 방법에 의하여 서비스 제공을 신청하며, 회사는 이용자가 신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공합니다.</p>
                  <div className="terms-list-item">
                    <p>가. 서비스의 검색 및 선택</p>
                    <p>나. 이용자의 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력</p>
                    <p>다. 서비스의 제공 신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의</p>
                    <p>라. 결제방법의 선택</p>
                  </div>
                  <p><strong>2.</strong> 회사가 제3자에게 이용자의 개인정보를 제공할 필요가 있는 경우 또는 회사가 제3자에게 이용자의 개인정보를 처리할 수 있도록 
                  업무를 위탁하는 경우에는 개인정보처리방침에 따라 처리합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제10조 (계약의 성립)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 제9조와 같은 서비스 제공신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다.</p>
                  <div className="terms-list-item">
                    <p>가. 신청 내용에 허위, 기재누락, 오기가 있는 경우</p>
                    <p>나. 미성년자가 청소년보호법에서 금지하는 서비스의 제공을 신청하는 경우</p>
                    <p>다. 기타 제공신청에 승낙하는 것이 리옵스에이아이의 기능 또는 기술상 현저히 지장이 있다고 판단하는 경우</p>
                  </div>
                  <p><strong>2.</strong> 회사는 이용자의 신청이 있는 경우 이용자에게 수신확인 통지를 하며, 회사의 승낙이 수신확인 통지 형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제11조 (대금지급 방법)</h2>
                <p>서비스에 대한 대금지급 방법은 다음 각 호의 방법 중 가용한 방법으로 할 수 있습니다.</p>
                <div className="terms-list-item">
                  <p>1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</p>
                  <p>2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</p>
                  <p>3. 온라인 무통장 입금</p>
                  <p>4. 전자화폐에 의한 결제</p>
                  <p>5. 수령 시 대금 지급</p>
                  <p>6. 마일리지 등 리옵스에이아이가 지급한 포인트에 의한 결제</p>
                  <p>7. 리옵스에이아이와 계약을 맺었거나 리옵스에이아이가 인정한 상품권에 의한 결제</p>
                  <p>8. 기타 전자적 지급 방법에 의한 대금 지급 등</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제12조 (서비스의 제공)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 이용자와 서비스 등의 제공시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 시점부터 즉시 서비스를 제공할 수 있도록 필요한 조치를 취합니다.</p>
                  <p><strong>2.</strong> 회사는 이용자가 제공받고자 하는 서비스 등에 대해 서비스 제공 방법 및 기간 등을 명시합니다.</p>
                  <p><strong>3.</strong> 회사의 일부 유료 서비스는 반복적, 주기적으로 이용 대금이 자동으로 결제됩니다. 회사는 이용자가 반복적, 주기적으로 자동 결제되는 서비스를 신청 시 이를 이용자에게 알려야 합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제13조 (청약의 철회 혹은 환불)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 유료 서비스를 일정기간 무료로 사용해 볼 수 있는 서비스를 제공하는 대신, 유료 서비스에 대한 청약의 철회(또는 서비스 해지) 및 
                  지급된 서비스 대금의 환불은 다음 표에 따라 처리합니다.</p>

                  <div className="terms-table-wrapper">
                    <table className="terms-table">
                      <thead>
                        <tr>
                          <th style={{width: '150px'}}>해지 대상 서비스 종류</th>
                          <th>진행되는 절차</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td rowSpan={2}><strong>회원 탈퇴하지 않는 경우</strong></td>
                          <td>
                            <strong>월간 유료 서비스</strong><br />
                            환불은 서비스를 이용한 일수를 제외하고 일할 계산으로 진행됩니다. 월 기준은 30이고 월 이용료를 30으로 나눈 금액을 말합니다. 
                            16일 이후 30일 이내 사용자는 환불이 불가능합니다. 일할 계산은 카드 수수료와 위약금을 포함한 결제 금액의 20% 금액을 제외한 금액이며, 
                            남은 일 수에 대한 일할 계산으로 환불 처리됩니다.<br />
                            <div className="terms-formula">계산 방식: [(전체 결제금액 * 0.8/30) * 남은 일수]</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>연간 유료 서비스 이용자</strong><br />
                            - 탈퇴 의사를 표시한 시점에 연간 유료 서비스 철회(해지) 신청한 것으로 간주하고 처리
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <p><strong>2.</strong> 이용자가 서비스 제공 대금을 완납하지 않는 경우 회사는 강제로 청약을 철회할 수 있습니다.</p>
                  <p><strong>3.</strong> 청약철회에 관하여 「전자상거래 등에서의 소비자보호에 관한 법률」에 달리 정함이 있는 경우에는 동 법 규정에 따릅니다.</p>
                  <p><strong>4.</strong> 서비스의 내용이 표시·광고 내용과 다르거나 계약 내용과 다르게 이행된 때에는 이용자는 당해 서비스를 공급받은 날부터 3일 이내, 
                  그 사실을 안 날 또는 알 수 있었던 날부터 7일 이내에 청약철회 등을 할 수 있습니다.</p>
                  <p><strong>5.</strong> 유료 서비스의 환불은 결제의 방식(현금 지급 또는 카드 결제의 방식)과 동일하게 다음 각 호에 따라 진행됩니다.</p>
                  <div className="terms-list-item">
                    <p>가. 현금 지급(계좌이체)방식으로 결제한 경우 이체한 동일 계좌로 영업일 기준 5일 이내에 환불 금액이 입금됩니다.</p>
                    <p>나. 카드 결제 방식으로 결제한 경우, 결제 당시 승인한 내역을 취소하는 방식으로 환불 처리됩니다.</p>
                  </div>
                  <p><strong>6.</strong> 유료 서비스 이용 중 회원 탈퇴를 원하는 경우, 고객센터를 통해 문의를 접수할 수 있습니다.</p>
                  <p><strong>7.</strong> 현행 법령, 중대한 약관 위반 등 이용자의 귀책사유로 청약의 철회(또는 서비스 해지)를 하는 경우 서비스 대금의 환불이 제한될 수 있습니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제14조 (개인정보보호)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 본 약관에서는 이하의 내용에도 불구하고 개인정보 처리방침이 우선 적용됩니다.</p>
                  <p><strong>2.</strong> 회사는 이용자의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.</p>
                  <p><strong>3.</strong> 회사는 이용자의 회원 가입 시 서비스 제공 계약의 이행에 필요한 정보를 미리 수집하지 않습니다.</p>
                  <p><strong>4.</strong> 회사는 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.</p>
                  <p><strong>5.</strong> 회사는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용 목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 
                  이용·제공 단계에서 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.</p>
                  <p><strong>6.</strong> 회사가 제3항과 제4항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원, 정보의 수집목적 및 이용목적, 
                  제3자에 대한 정보제공 관련사항 등을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.</p>
                  <p><strong>7.</strong> 이용자는 언제든지 회사가 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며, 회사는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다.</p>
                  <p><strong>8.</strong> 회사 또는 회사로부터 개인정보를 제공받은 제3자는 개인정보의 수집 목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.</p>
                  <p><strong>9.</strong> 회사는 개인정보의 수집·이용·제공에 관한 이용자의 동의 거절 시 제한되는 서비스를 구체적으로 명시하고, 필수 수집항목이 아닌 개인정보의 수집·이용·제공에 관한 
                  이용자의 동의 거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다.</p>
                  <p><strong>10.</strong> 이용자 또는 회원이 이미 공개적으로 리옵스에이아이를 이용하여 진단/분석을 진행하였거나 진행하고 있는 경우, 회사는 해당 이용자 또는 회원이 리옵스에이아이 이용자임을 
                  대외적으로 광고 또는 홍보할 수 있습니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제15조 (회사의 의무)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 본 약관이 정하는 바에 따라 지속적이고 안정적으로 서비스를 제공하는데 최선을 다하여야 합니다.</p>
                  <p><strong>2.</strong> 회사는 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안 시스템을 갖추어야 합니다.</p>
                  <p><strong>3.</strong> 회사가 서비스에 대하여 「표시·광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.</p>
                  <p><strong>4.</strong> 회사는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제16조 (회원의 계정 관리에 대한 의무)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 구글 등 외부 인증 연동(OAuth)을 통해 회원가입 및 로그인을 제공하므로, 회원의 계정 관리책임은 해당 외부 인증 서비스 제공자와 회원에게 있습니다.</p>
                  <p><strong>2.</strong> 회원은 자신의 계정을 제3자에게 이용하게 해서는 안 됩니다. 1개의 계정은 이용자 1명만 사용할 수 있습니다.</p>
                  <p><strong>3.</strong> 회원이 자신의 계정이 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제17조 (이용자의 의무)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 이용자는 다음 각 호의 행위를 하여서는 안 됩니다.</p>
                  <div className="terms-list-item">
                    <p>가. 신청 또는 변경 시 허위 내용의 등록</p>
                    <p>나. 타인의 정보 도용</p>
                    <p>다. 서비스에 게시된 정보의 변경</p>
                    <p>라. 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</p>
                    <p>마. 회사, 서비스 및 기타 제3자의 저작권 등 지식재산권 침해</p>
                    <p>바. 회사, 서비스 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</p>
                    <p>사. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하거나 서비스를 이용해 제작하고 게시하는 행위</p>
                    <p>아. 회사의 사전 서면 동의 없이 서비스를 대여 또는 재판매하는 행위</p>
                    <p>자. 다른 회원의 개인정보를 수집하는 행위</p>
                    <p>차. 서비스에 국가 기밀, 회사의 대외비 정보(Confidential Information), 제3자의 민감한 개인정보 등 유출 시 문제가 될 수 있는 정보를 입력하는 행위</p>
                  </div>

                  <p><strong>2.</strong> 이용자가 리옵스에이아이를 통해 생성한 결과 값이나 진단/분석 자료를 제3자에게 공개하거나 광고 또는 홍보 목적으로 사용하는 경우 또는 언론 매체 등을 통해 공표하는 경우, 
                  다음과 같이 출처를 반드시 표기해야 합니다. 단, 제2호에 따른 예외사항의 경우에는 그러하지 아니합니다.</p>

                  <div className="terms-list-item">
                    <p><strong>가. 출처 표기 방법</strong></p>
                    <ul>
                      <li>기사 본문: "리옵스에이아이를 통해 진단/분석한 결과" 또는 이에 준하는 표현으로 분석 도구명을 명시</li>
                      <li>시각화 자료: 차트, 그래프 등 시각화 자료에 "진단/분석 도구: 리옵스에이아이" 표기</li>
                      <li>방송 리포트: 분석 내용을 소개할 때 "리옵스에이아이"라는 도구명을 언급</li>
                    </ul>
                  </div>

                  <div className="terms-list-item">
                    <p><strong>나. 다음의 경우에는 제1호의 출처 표기 방법에 따른 의무가 적용되지 않습니다.</strong></p>
                    <ul>
                      <li>개인적, 비상업적 용도의 활용</li>
                      <li>학술 목적의 연구 발표 (일반적인 학술 인용 규칙 적용)</li>
                      <li>내부 보고서 또는 비공개 문서에서의 활용</li>
                    </ul>
                  </div>

                  <p><strong>3.</strong> 이용자는 제2항의 출처 표기 의무를 위반할 경우 서비스 이용에 제한을 받을 수 있으며, 이로 인한 법적 책임은 이용자가 부담합니다.</p>
                  <p><strong>4.</strong> 출처 표기 방법에 대한 세부 사항이나 문의사항이 있는 경우, 이용자는 고객센터를 통해 안내 받을 수 있습니다.</p>
                  <p><strong>5.</strong> 이용자는 서비스를 이용하거나 그 서비스의 결과 값이나 분석 자료를 이용함에 있어서 제3자의 저작권, 상표권 등 지식재산권을 침해하는 방법으로 이용하여서는 아니 됩니다.</p>

                  <p><strong>6.</strong> 이용자는 아래와 같은 사항을 인지하고 이를 확인 및 동의하며, 그 의무를 이행해야 합니다.</p>
                  <div className="terms-highlight">
                    <ul>
                      <li>리옵스에이아이는 개인정보를 처리하기 위한 목적의 서비스가 아니라는 점</li>
                      <li>리옵스에이아이는 이용자가 (회원 가입이 아닌 서비스의 결과 값이나 분석 시각화 자료를 도출하기 위해) 입력한 정보를 보관하거나 제3자에게 그대로 위탁하지도 않는다는 점</li>
                      <li>개인정보를 리옵스에이아이에 입력하여 개인정보보호법 등 법령 위반 문제가 발생할 경우, 이에 대해 회사는 책임지지 않는 다는 점</li>
                    </ul>
                  </div>

                  <p><strong>7.</strong> 이용자가 본 약관을 위반함으로써 회사에게 손해가 발생하는 경우 이를 위반한 이용자는 회사에 발생한 모든 손해를 배상해야 하며, 그 손해로부터 회사를 면책시켜야 합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제18조 (면책)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.</p>
                  <p><strong>2.</strong> 회사는 기간 통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우에 대한 책임이 면제됩니다.</p>
                  <p><strong>3.</strong> 회사는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.</p>
                  <p><strong>4.</strong> 회사는 이용자의 귀책사유로 인한 서비스의 이용 장애 또는 손해에 대하여 책임이 면제됩니다.</p>
                  <p><strong>5.</strong> 회사에서 이용자에게 무료로 제공하는 서비스의 이용과 관련해서는 어떠한 손해도 책임을 지지 않습니다.</p>
                  <p><strong>6.</strong> 회사에서 이용자에게 제공하는 리서치 계획서, 스크리닝 설문의 세부 내용에서 서비스 관련 정보의 정확성, 신뢰도 등의 내용에 대해서는 책임을 지지 않습니다.</p>
                  <p><strong>7.</strong> 회사는 이용자가 서비스에 입력한 각종 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 대하여 책임을 지지 않으며, 이용자와 제3자 간 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없고, 이로 인한 손해를 배상할 책임도 없습니다.</p>
                  <p><strong>8.</strong> 회사는 서비스 제공이 중지되는 콘텐츠에 대해 이용자에게 공지한 후 이용자가 해당 콘텐츠를 사용함으로 인해 발생하는 분쟁에 대해서 책임을 지지 않습니다.</p>
                  <p><strong>9.</strong> 회사는 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우 또는 이용자가 개인정보 및 전자우편(E-MAIL) 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다.</p>
                  <p><strong>10.</strong> 회사는 이용자가 서비스를 이용하면서 얻은 자료로 인한 손해에 대하여 책임을 지지 않습니다.</p>
                  <p><strong>11.</strong> 회사는 이용자가 입력한 데이터 또는 그 데이터를 기반으로 생성된 콘텐츠를 사전심사 하거나 상시적으로 내용을 확인 또는 검토하여야 할 의무가 없으며, 그 결과에 대한 책임을 지지 아니합니다.</p>
                  <p><strong>12.</strong> 리옵스에이아이가 서비스 제공에 활용하는 외부 LLM 서비스 등 외부 제휴업체의 사유로 정상적인 서비스 제공이 어려운 경우, 회사는 서비스 제공에 대한 책임이 면제됩니다.</p>
                  <p><strong>13.</strong> 회사는 이용자가 서비스에 입력한 정보가 개인정보, 기업의 영업비밀, 기타 대외비 정보에 해당하여 발생한 유출 사고나 손해에 대해서는 책임을 지지 않습니다. 중요한 보안이 요구되는 정보는 입력하지 않아야 할 의무는 이용자 본인에게 있습니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제19조 (분쟁해결)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 이용자로부터 제출되는 불만사항 및 의견을 우선적으로 처리합니다. 단, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리 일정을 즉시 통보합니다.</p>
                  <p><strong>2.</strong> 회사와 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제20조 (재판권 및 준거법)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 본 약관에 명시되지 않은 사항은 전기통신사업법 등 대한민국의 관계법령과 상관습에 따릅니다.</p>
                  <p><strong>2.</strong> 회사와 이용자 간에 발생한 분쟁에 대하여 소송이 제기되는 경우 대한민국 서울중앙지방법원을 전속적인 합의관할 법원으로 합니다.</p>
                </div>
              </section>

              <section className="terms-section">
                <h2>제21조 (외부 데이터셋 및 오픈소스 고지)</h2>
                <div className="terms-subsection">
                  <p><strong>1.</strong> 회사는 서비스 제공을 위하여 오픈소스 소프트웨어 및 공개 데이터셋 등 제3자 자료를 활용할 수 있으며, 해당 자료의 라이선스 조건을 준수합니다.</p>
                  <p><strong>2.</strong> 회사는 AI 퍼소나 생성 기능의 시드(seed) 자료로 NVIDIA Corporation의 Nemotron-Personas-Korea 데이터셋을 활용하며, 해당 데이터셋은 Creative Commons Attribution 4.0 International (CC BY 4.0) 라이선스에 따라 제공됩니다. 원본 데이터셋은 다음 주소에서 확인할 수 있습니다.</p>
                  <div className="terms-list-item">
                    <p>
                      <a
                        href="https://huggingface.co/datasets/nvidia/Nemotron-Personas-Korea"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://huggingface.co/datasets/nvidia/Nemotron-Personas-Korea
                      </a>
                    </p>
                  </div>
                  <p><strong>3.</strong> 회사는 제2항의 데이터셋을 서비스 목적에 맞게 선별·매핑·가공·변형하여 사용하며, 이용자에게 제공되는 퍼소나 및 관련 결과물은 원본 데이터셋과 동일하지 않을 수 있습니다.</p>
                  <p><strong>4.</strong> 제2항의 데이터셋에 대한 저작권 및 관련 권리는 원 권리자에게 귀속되며, 본 고지는 CC BY 4.0에 따른 저작자표시를 위한 것입니다. 회사는 NVIDIA Corporation과 제휴·보증·후원 관계에 있지 않으며, 해당 명칭의 사용이 그러한 관계를 의미하지 않습니다.</p>
                  <p><strong>5.</strong> 회사는 서비스에 활용하는 외부 데이터셋 및 오픈소스 고지 내용을 관련 라이선스 요건 및 서비스 운영상 필요에 따라 본 조에 추가·변경할 수 있습니다.</p>
                </div>
              </section>
            </div>

          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="terms-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>ReOpsAI</h3>
            </div>
            <div className="footer-links">
              <Link to="/terms">이용약관</Link>
              <Link to="/privacy">개인정보/데이터처리방침</Link>
            </div>
            <div className="footer-copy">
              <p>ReOpsAI © 2025</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfServicePage;

